// extracted by mini-css-extract-plugin
export default {"svg":"TickIcon_svg__IlR6V","active":"TickIcon_active__lud5-"};